module.exports = __webpack_public_path__ + "media/images/games/k2reveal/bee-7364e2abbe0c463f03fd600b828b751a.png";